export default __webpack_public_path__ + "static/media/leaderboard.fe432bce.png";